import type { Filter } from '@graphit/types'
import axios from 'axios'

import type { DeepPartial } from 'typeorm'

import env from '../environments'

export async function getFilters(cartographyId: string) {
	const response = await axios.get(`${env.apiUrl}/filters/cartography/${cartographyId}`)

	return response.data as Filter[]
}

export async function getFilter(id: string) {
	const response = await axios.get(`${env.apiUrl}/filters/${id}`)

	return response.data as Filter
}

export async function createFilter(filterData: DeepPartial<Filter>) {
	const response = await axios.post(`${env.apiUrl}/filters/create`, {
		filterData
	})

	return response.data as Filter
}

export async function updateFilter(id: string, filterData: Partial<Filter>) {
	const response = await axios.put(`${env.apiUrl}/filters/${id}`, {
		filterData
	})

	return response.data as Filter
}

export async function deleteFilter(id: string) {
	await axios.delete(`${env.apiUrl}/filters/${id}`)
}
